import { useQuery } from '@tanstack/react-query';

import { fetchOccupancy } from './warehouseApi.js';

// No refetchInterval here on purpose — the user said no live updates for v1.
// Mutations in useItems.js / useTrips.js invalidate ['warehouse','occupancy']
// on success, which matches this key hierarchically and triggers a refresh.
export function useOccupancy(buildingId) {
  return useQuery({
    queryKey: ['warehouse', 'occupancy', buildingId],
    queryFn: () => fetchOccupancy(buildingId),
    enabled: !!buildingId,
    staleTime: 30_000,
  });
}
